<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-card style="padding: 10px;margin-bottom: 5px" v-if=" documents && documents._status===false">
            <v-alert dense outlined type="error">
              {{$t('documents.document_en_attente')}}
            </v-alert>
        </v-card>
       
        <v-card elevation="0" style="background: transparent!important;" class="api mt-4">
            <v-tabs v-model="api_tabs">
                <v-tab>Api</v-tab>
                <v-tab>Webhook</v-tab>
                <v-tab>{{$t("templates.management")}}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="api_tabs" style="background: transparent!important;">
                <v-tab-item>
                    <div v-if="keys" class="col-12 col-lg-12 col-md-12 col-xs-12">
                        <v-form cols="12">
                            <v-row style="margin-bottom: 20px;background: #fff!important;border-radius: 10px">

                                <v-col cols="12" sm="12">
                                  <v-alert v-if="marchandu && marchandu._env==='live'" type="info">
                                        {{$t('developers.info_key')}}
                                    </v-alert>
                                    <v-alert v-if="marchandu && marchandu._env==='sandbox'" type="warning">
                                        {{$t('developers.warning_key')}}
                                    </v-alert>
                                 </v-col>
                                <v-col cols="12" sm="8">
                                    <h3 class="text-uppercase" style="font-weight:200">{{$t('developers.marchand_key')}}</h3>
                                    <v-text-field style="margin-bottom: 0!important;" class="api_key_val" readonly append-icon="mdi-content-copy" type="text" :label="$t('developers._marchand_key')" :value="this.$store.getters.auth._id" single-line solo @click:append="copy($store.getters.auth._id)"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: 20px;background: #fff!important;border-radius: 10px">
                                <v-col cols="12" sm="8">
                                    <h3 class="text-uppercase" style="font-weight:200">{{$t('developers.public_key')}}</h3>
                                    <v-text-field style="margin-bottom: 0!important;" class="api_key_val" readonly append-icon="mdi-content-copy" type="text" :label="$t('developers._public_key')" :value="keys._public_key" single-line solo @click:append="copy(keys._public_key)"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row  style="margin-bottom: 20px;background: #fff!important;border-radius: 10px">
                                <v-col cols="12" sm="8">
                                    <h3 class="text-uppercase" style="font-weight:200">{{$t('developers.private_key')}}</h3>
                                    <v-text-field class="api_key_val" readonly append-icon="mdi-content-copy" type="text" :value="keys._private_key" :label="$t('developers.private_key')" @click:append="copy(keys._private_key)" single-line solo></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row  style="margin-bottom: 20px;background: #fff!important;border-radius: 10px">
                                <v-col cols="12" sm="8">
                                    <h3 class="text-uppercase" style="font-weight:200">{{$t('developers.secret_key')}}</h3>
                                    <v-text-field class="api_key_val" readonly append-icon="mdi-content-copy" type="text" :label="$t('developers.secret_key')" :value="keys._secret_key" single-line solo @click:append="copy(keys._secret_key)"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>

                  
                    </div>
                    <div v-else class="col-lg-12 col-xs-12 col-md-12">
                        <v-form>
                             <v-row>
                                <v-col cols="12" sm="8">
                                    <h3 style="font-weight:200">{{$t('developers.marchand_key')}}</h3>
                                    <v-text-field 
                                            class="api_key_val"
                                            readonly
                                            append-icon="mdi-content-copy"
                                            type="text"
                                            :label="$t('developers.marchand_key')"
                                            :value="$t('developers.marchand_key')"
                                            single-line solo
                                            @click:append="copy('clé')"
                                    ></v-text-field>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <h3 style="font-weight:200">{{$t('developers.public_key')}}</h3>
                                    <v-text-field
                                            class="api_key_val"
                                            readonly
                                            append-icon="mdi-content-copy"
                                            type="text"
                                            :label="$t('developers.public_key')"
                                            :value="$t('developers.public_key')"
                                            single-line solo
                                            @click:append="copy('clé')"
                                    ></v-text-field>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <h3 style="font-weight:200">{{$t('developers.private_key')}}</h3>
                                    <v-text-field
                                            class="api_key_val"
                                            readonly
                                            append-icon="mdi-content-copy"
                                            type="text"
                                            :value="$t('developers.private_key')"
                                            :label="$t('developers.private_key')"
                                            @click:append="copy('clé')"
                                            single-line solo></v-text-field>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <h3 style="font-weight:200">{{$t('developers.secret_key')}}</h3>
                                    <v-text-field
                                            class="api_key_val"
                                            readonly
                                            append-icon="mdi-content-copy"
                                            type="text"
                                            :label="$t('developers.secret_key')"
                                            :value="$t('developers.secret_key')"
                                            single-line solo
                                            @click:append="copy('clé')"
                                    ></v-text-field>
                                </v-col>

                            </v-row>

                        </v-form>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <Webhook></Webhook>
                </v-tab-item>
                <v-tab-item>
                   <MarchandTemplate></MarchandTemplate>
                </v-tab-item>

            </v-tabs-items>

        </v-card>
        <template>
            <div class="text-center ma-2">
                <v-snackbar v-model="snackbar">
                    {{ text }}
                    <template v-slot:action="{ attrs }">
                        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
                            {{$t("fermer")}}
                        </v-btn>
                    </template>
                </v-snackbar>
            </div>
        </template>
        </div>
</template>

<script>
    import helpers from "../../../../../mixins/helpers";
    import MarchandTemplate from "./MarchandTemplate";
    import Webhook from "./Webhook";
    import {mapState} from "vuex";

    export default {
        name: "DeveloperApi",
        components: {MarchandTemplate,Webhook},
        mixins: [helpers(this)],
        data() {
            return {
                api_tabs: null,
                snackbar: false,
                text:'',
                sdk_tabs: null,
                types: ['Places to Be', 'Places to See'],
                cards: ['Good', 'Best', 'Finest'],
                socials: [
                    {
                        icon: 'mdi-facebook',
                        color: 'indigo',
                    },
                    {
                        icon: 'mdi-linkedin',
                        color: 'cyan darken-1',
                    },
                    {
                        icon: 'mdi-instagram',
                        color: 'red lighten-3',
                    },
                ],
            }
        },
        computed: {
            ...mapState('documents/',['documents']),
            ...mapState('marchands/',['marchandu']),
            keys: function () {
                return JSON.parse(sessionStorage.getItem("keys"))
            },
        },
        mounted(){
            this.$store.dispatch('documents/getDocument',this.$store.getters.marchand._id).then(response=>{
                console.log('mon docs',response)
                //this.documents=response.message
            });

        },
        created() {
            this.checkisDashboard();
        },
        methods: {
            copy(text) {
                let VueBox = this;
                this.$copyText(text).then(function (e) {
                    VueBox.text = VueBox.$t("copie")+ e.text;
                    VueBox.snackbar = true;

                }, function () {
                    VueBox.text = VueBox.$t("copiefailed");
                    VueBox.snackbar = true;

                })
            },
            getImage () {
                const min = 550
                const max = 560
                return Math.floor(Math.random() * (max - min + 1)) + min
            },
        },
    }

</script>

<style scoped>

    .circle-icon {
        background: #29B3A6;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-top: -30%;
        margin-left: 53%;
    }

    .circular--square {
        border-radius: 50%;
    }

    .circular--square {
        border-radius: 50% 50%;
        width: 170px;
        height: 170px;
        object-fit: contain;
    }

    .img-icon-holder {
        margin-left: 60%;
        padding: 8px;
        background-color: #29B3A6;
        border-radius: 50%;
    }

    /*.circular--portrait {
        position: relative;
        width: 200px;
        height: 200px;
        overflow: hidden;
        border-radius: 50%;
    }

    .circular--portrait img {
        width: 100%;
        height: auto;
    }*/
    .v-sheet.v-toolbar:not(.v-sheet--outlined), .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
        border: none !important;
    }
</style>
